import { render } from "./CollectionGroup.vue?vue&type=template&id=c2b7d7b8&scoped=true"
import script from "./CollectionGroup.vue?vue&type=script&lang=js"
export * from "./CollectionGroup.vue?vue&type=script&lang=js"

import "./CollectionGroup.vue?vue&type=style&index=0&id=c2b7d7b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b7d7b8"]])

export default __exports__